import React, { useMemo, useState } from 'react';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FixedJobsByWeekday } from '@/components/admin/fixed-jobs/FixedJobsByWeekday';
import { AdminDailySchedule } from '@/components/admin/fixed-jobs/AdminDailySchedule';

export default function AdminJobsPage() {
  const [teacherCode, setTeacherCode] = useState<string>('');
  const normalizedTeacherCode = useMemo(() => teacherCode.trim(), [teacherCode]);

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container mx-auto px-4 py-8 space-y-6">
            <Card>
              <CardHeader>
                <CardTitle>จัดการตารางประจำ (Fixed Jobs)</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="max-w-md">
                  <label className="block text-sm font-medium mb-1">รหัสครู (teacher_code)</label>
                  <Input
                    placeholder="เช่น TCH001"
                    value={teacherCode}
                    onChange={(e) => setTeacherCode(e.target.value)}
                  />
                </div>

                <Tabs defaultValue="list" className="w-full">
                  <TabsList>
                    <TabsTrigger value="list">รายการรายวัน (0–6)</TabsTrigger>
                    <TabsTrigger value="daily">ตารางรายวัน</TabsTrigger>
                  </TabsList>
                  <TabsContent value="list">
                    <FixedJobsByWeekday teacherCode={normalizedTeacherCode || undefined} />
                  </TabsContent>
                  <TabsContent value="daily">
                    <AdminDailySchedule teacherCode={normalizedTeacherCode || undefined} />
                  </TabsContent>
                </Tabs>
              </CardContent>
            </Card>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}


